import styled from 'styled-components';

export const PageContainer = styled.div`
  background: #0d1117;
  color: white;
  min-height: calc(100vh - 80px); // Subtract footer height
  display: flex;
  flex-direction: column;
`;

export const PageWrapper = styled.div`
  background: #0d1117;
  color: white;
  min-height: calc(100vh - 80px);
  display: flex;
  flex-direction: column;
`;

export const Container = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 6rem 2rem;
  width: 100%;

  @media (max-width: 768px) {
    padding: 4rem 1rem;
  }
`;

export const Section = styled.section`
  padding: 6rem 2rem;

  @media (max-width: 768px) {
    padding: 4rem 1rem;
  }
`;

export const SectionTitle = styled.h2`
  font-size: 3rem;
  font-weight: 800;
  text-align: center;
  margin-bottom: 3rem;
  background: linear-gradient(90deg, #fff, #b3b3b3);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  @media (max-width: 768px) {
    font-size: 2.5rem;
    margin-bottom: 2rem;
  }
`; 